import { render, staticRenderFns } from "./KgjtWebsiteProductEdit.vue?vue&type=template&id=3023e8b2&scoped=true&"
import script from "./KgjtWebsiteProductEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteProductEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteProductEdit.vue?vue&type=style&index=0&id=3023e8b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023e8b2",
  null
  
)

export default component.exports